import React from 'react'
import FAQForm from './FAQForm'

const EditFaq = () => {
  return (
    <FAQForm title="Edit Faq"/>
  )
}

export default EditFaq
